import { render, staticRenderFns } from "./LayoutInsights.vue?vue&type=template&id=c751f7ce&"
import script from "./LayoutInsights.vue?vue&type=script&lang=js&"
export * from "./LayoutInsights.vue?vue&type=script&lang=js&"
import style0 from "./LayoutInsights.vue?vue&type=style&index=0&id=c751f7ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports